export class InvoicePaymentPeriod {
	period: string
    paymentsValue: number
    invoicesValue: number
	vatValue: number
}